export enum Actions {
  CHANGE_STORE = 'CHANGE_STORE',
}
